import styled from '@emotion/styled';

export const CardNoticeContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	background-color: #fff;
	border-radius: 1.6rem;
	flex: 1;
	height: 100%;
	min-height: 38rem;
`;
